import { RefreshCw, TriangleAlert } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "~/design/plans";
import Button from "~/design/ui/Button";
import StatusScreen, { StatusIcon } from "./StatusScreen";

// type="error" is a failure (danger); without a type (409, stale token) it is a recoverable warning.
function MessageCardError(props) {
  const { t } = useTranslation();
  const [countdown, setCountdown] = React.useState(props.autoReloadAfter / 1000);

  React.useEffect(() => {
    let timeout: number | undefined;
    if (props.autoReloadAfter) {
      timeout = setTimeout(() => {
        window.location.reload();
      }, props.autoReloadAfter);

      return () => clearTimeout(timeout);
    }
  }, [props.autoReloadAfter]);

  React.useEffect(() => {
    let interval: number | undefined;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [countdown]);

  const danger = props.type === "error";
  return (
    <StatusScreen
      icon={<StatusIcon tone={danger ? "danger" : "warning"}>{danger ? <TriangleAlert strokeWidth={1.75} aria-hidden /> : <RefreshCw strokeWidth={1.75} aria-hidden />}</StatusIcon>}
      title={props.title}
      description={props.description}
      action={
        props.toDoHref && (
          <Button href={props.toDoHref} size="lg" block>
            {props.toDo}
          </Button>
        )
      }
      footer={
        props.autoReloadAfter && (
          <p className="mt-4 text-sm text-ink-3" aria-live="polite">
            {t("ui.checkout.status.reloadIn", { seconds: formatNumber(Math.max(0, countdown)) })}
          </p>
        )
      }
    >
      {props.children}
    </StatusScreen>
  );
}

export default MessageCardError;
